<ng-container>
  @for (option of options; track option) {
    <checkbox-container>
      <pr-input-checkbox
        [formControlName]="option.value"
        [label]="[option.label]"
      >
      </pr-input-checkbox>
    </checkbox-container>
  }
</ng-container>
